import __request__ from "routing/request";
export function executeForEvents(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/security_events/notifications", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function executeForEvent(eventId, notificationId, stepId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp/security_events/notifications/${eventId}/${notificationId}`, null, { "stepId": stepId }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
